import React from "react";
import {
  FaDiscord,
  FaTelegram,
  FaTiktok,
  FaFacebookF,
  FaXTwitter,
  FaRedditAlien,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
  FaLinkedinIn,
  FaGithub,
  FaLink,
} from "react-icons/fa6";
import { Link } from "react-router-dom";
import { useContent, useSiteConfig } from "./SiteConfigContext";

const socialIcons = {
  x: FaXTwitter,
  twitter: FaXTwitter,
  telegram: FaTelegram,
  instagram: FaInstagram,
  facebook: FaFacebookF,
  youtube: FaYoutube,
  discord: FaDiscord,
  tiktok: FaTiktok,
  reddit: FaRedditAlien,
  whatsapp: FaWhatsapp,
  linkedin: FaLinkedinIn,
  github: FaGithub,
};

function FooterItem({ item }) {
  if (!item.url) return <li>{item.label}</li>;
  if (item.newTab || /^(https?:|mailto:)/i.test(item.url)) {
    return <li><a href={item.url} target={item.newTab ? "_blank" : undefined} rel="noreferrer">{item.label}</a></li>;
  }
  return <li><Link to={item.url}>{item.label}</Link></li>;
}

function Footer() {
  const { footerColumns, socialLinks } = useSiteConfig();
  const copyright = useContent("footer_copyright", "");

  return (
    <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
      <div className="py-16 px-4 md:px-12 text-sm">
        <div className="max-w-screen-xl mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-8">
          {socialLinks.length > 0 && (
            <div>
              <h4 className="font-semibold mb-4">Community</h4>
              <div className="flex flex-wrap gap-3 text-xl mb-4">
                {socialLinks.map((link) => {
                  const Icon = socialIcons[link.platform] || FaLink;
                  return (
                    <a key={link.platform + link.url} href={link.url} aria-label={link.label} target="_blank" rel="noreferrer">
                      <Icon />
                    </a>
                  );
                })}
              </div>
            </div>
          )}

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-semibold mb-4">{column.title}</h4>
              <ul className="space-y-1">
                {column.items.map((item) => <FooterItem key={item.label} item={item} />)}
              </ul>
            </div>
          ))}
        </div>
        {copyright && <p className="max-w-screen-xl mx-auto mt-10 text-center opacity-70">{copyright}</p>}
      </div>
    </div>
  );
}

export default Footer;
